var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "ai-chat aiInterviewConsultantDialog" },
    [
      _c(
        "Drawer",
        _vm._g(
          {
            attrs: { drawerVisible: _vm.drawerVisible },
            scopedSlots: _vm._u([
              {
                key: "content",
                fn: function ({ data }) {
                  return [
                    _vm.drawerVisible
                      ? _c(
                          "Chat",
                          _vm._g(
                            {
                              attrs: {
                                apiBaseUrl: _vm.apiBaseUrl,
                                suggestQuestionsProp: _vm.suggestQuestions,
                                interview: _vm.interview,
                                source: _vm.source,
                              },
                            },
                            _vm.$listeners
                          )
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          },
          _vm.$listeners
        )
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }